/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParams,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage401,
  GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage } from "../../clients/individualPaymentEditorsController/getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage.ts";

export const getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryKey =
  (
    scholarshipTypeId: GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParams["scholarshipTypeId"],
  ) =>
    [
      {
        url: "/api/v1/individualpayment/editors/scholarship-types/:scholarshipTypeId/percentage",
        params: { scholarshipTypeId: scholarshipTypeId },
      },
    ] as const;

export type GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryKey
  >;

export function getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryOptions(
  scholarshipTypeId: GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParams["scholarshipTypeId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryKey(
      scholarshipTypeId,
    );
  return queryOptions<
    GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage401
      | GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage500
    >,
    GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse,
    typeof queryKey
  >({
    enabled: !!scholarshipTypeId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage(
        scholarshipTypeId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Migrado do legado ScholarshipType/GetPercentageValue. **(Requer Authorization para autenticação)**
 * @summary Percentual da bolsa (apenas quando tem valor fixo) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/scholarship-types/:scholarshipTypeId/percentage}
 */
export function useGetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage<
  TData =
    GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryKey,
>(
  scholarshipTypeId: GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentagePathParams["scholarshipTypeId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage401
          | GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryKey(
      scholarshipTypeId,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentageQueryOptions(
        scholarshipTypeId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage401
      | GetApiV1IndividualpaymentEditorsScholarshipTypesScholarshiptypeidPercentage500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
